export default __webpack_public_path__ + "static/media/open-xdr-graphic-illustration.97d4e14c.svg";